<template>
    <v-container fluid>
      <div>
        <v-img src="../assets/images/home_slides/main_banner.png"/>
      </div>
      <v-row>

        <v-col cols="12" md="6">
          <v-col>
            <v-card
                class="mx-auto"
            >
              <v-card-text>
                <p class="display-1 text--primary">
                  Features
                </p>
                <v-list
                    subheader
                >
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Custom Search Settings</v-list-item-title>
                      <v-list-item-subtitle>Change the search settings for your sub.  Adjust things like max age of matches and % match</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Admin Abilities</v-list-item-title>
                      <v-list-item-subtitle>Take action when a repost is found! Choose if the bot removes, locks, comments and more when it finds a respost</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Easy Management Portal</v-list-item-title>
                      <v-list-item-subtitle>Configure the bot through the easy to use admin portal. Change settings, view repost history and customize the bot from here!</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-btn
                    text
                    color="orange"
                    to="/my-subreddits"
                >
                  Add to Your Subreddit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
        <v-col cols="12" md="6">
          <v-row class="mt-0 pt-0">
            <v-col cols="12" md="6" v-for="stat in stats" :key="stat.name">
              <StatCard :stat-name="stat.name" :state-value="stat.value"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-container>

</template>

<script>



import StatCard from "@/components/common/StatCard";
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
const StatsRepo = RepositoryFactory.get('stats')
export default {
  name: 'Home',
  data: () => ({
    stats: [
      {
        name: 'Times Summoned',
        statKey: 'summons_all',
        value: null
      },
      {
        name: 'Reposts Today',
        statKey: 'reposts_today',
        value: null
      },
      {
        name: 'Reposts Ever',
        statKey: 'reposts_all',
        value: null
      },
      {
        name: 'Protected Subs',
        statKey: 'subreddit_count',
        value: null
      },


    ],
  }),
  components: {
    StatCard,
  },
  methods: {
    fetchStat(statKey) {
      return StatsRepo.getHomeStats({'params': {stat_name: statKey}})
    }
  },
  mounted() {
    this.stats.forEach(stat => {
      this.fetchStat(stat.statKey)
        .then(res => {
          let index = this.stats.findIndex(x => x.statKey === stat.statKey)
          this.stats[index].value = res.data.count
        })
    })
  }
}
</script>
